export default __webpack_public_path__ + "static/media/DNo.32-0.579ef3c0.jpg";